import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';

import useFAQService from '../../../app/services/hooks/useFAQService';
import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import FAQForm from './forms/FAQForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface FAQFormData {
    question: string;
    answer: string;
    order: number;
}

const defaultFAQFormData: FAQFormData = {
    question: '',
    answer: '',
    order: 0
};

interface Props {
    faqId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const FAQEdit = ({ faqId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingShowFAQ, showFAQ, fetchingUpdateFAQ, updateFAQ } = useFAQService();

    const [faq, setFaq] = useState<FAQFormData>(defaultFAQFormData);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando pregunta frecuente...');
        showFAQ(faqId, {
            onSuccess: (response: ServiceResponse) => {
                const _faq = response.data.faq;
                setFaq({
                    question: _faq.question || '',
                    answer: _faq.answer || '',
                    order: _faq.order || 0
                });
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando pregunta frecuente...');
        updateFAQ(faqId, faq, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingShowFAQ ? (
        <LazyLoading height="300" />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <FAQForm
                        faqForm={faq}
                        setFaqForm={setFaq}
                        errorFields={errorFields}
                        isCreate={false}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingUpdateFAQ} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} locked={fetchingUpdateFAQ} />
                </div>
            </div>
        </>
    );
};

export default FAQEdit;

